<template>
	<div class="the_header">
		<div class="header_lt" @click="goPage">
			<img :src="siteLogo" height="41" alt="">
			<!-- <div class="logo_text">
				<p>国家应急安全标识注册管理公共服务平台</p>
				<p>中国安全生产科学研究院</p>
			</div> -->
		</div>
		<ul class="header_rt">
			<li>
				<img src="./../../../assets/images/guanliyuan.png" height="20" width="20" alt="">
				<!-- 您好～管理员：{{userInfo.username}} -->
				您好～管理员：{{unitInfo.unitName}}
			</li>
			<li @click="psdDialog=true">修改密码</li>
			<li @click="logout">退出系统</li>
		</ul>
		<!-- 修改密码 -->
        <el-dialog
            title="修改密码"
            :visible.sync="psdDialog"
            width="500px" :before-close="handleCanceledit">
            <el-form :model="form" :rules="rules" ref="form" label-width="80px" class="form_dialog">
                <el-form-item label="原密码" prop="oldPassword">
					<el-input type="password" v-model="form.oldPassword"></el-input>
				</el-form-item>
                <el-form-item label="新密码" prop="newPassword">
					<el-input type="password" v-model="form.newPassword"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="checkPass" required>
					<el-input type="password" v-model="form.checkPass"></el-input>
				</el-form-item>
                <div class="btn_wrap">
                    <el-button class="pub_green_btn" @click="submitForm">确定</el-button>
                </div>
            </el-form>
        </el-dialog>
	</div>
</template>
<script>
	import {mapState} from 'vuex'
	import {logout,password, websiteInfo} from '@/api/admin'
	export default {
		name: 'Header',
		data() {
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.form.newPassword) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				siteLogo: '',
				psdDialog:false,//修改密码弹框
				form: {
					oldPassword: '',//原密码
					newPassword: '',
					checkPass: '',
				},
				rules: {
					oldPassword: [
						{ required: true, message: '原密码不能为空', trigger: 'blur' },
						{ min: 6, message: '长度不少于6字符', trigger: 'blur' }
					],
					newPassword: [
						{ required: true, message: '新密码不能为空', trigger: 'blur' },
						{ min: 6, message: '长度不少于6字符', trigger: 'blur' }
					],
					checkPass: [
						{ validator: validatePass, trigger: 'blur' },
					],
				},
			}
		},
		computed:{
			...mapState({
				// userInfo(state){
				// 	console.log(state,"user")
				// 	state = state.user.userInfo
				// 	return state
				// },
				unitInfo(state){
					console.log(state,"user")
					// state = state.user.userInfo
					state = state.user.unitInfo
					return state
				},
			})
		},
		created() {
			this.getWebsite()
		},
		methods: {
			handleCanceledit() {
				this.$nextTick(() => {
					this.$refs['form'].clearValidate()
					this.$refs['form'].resetFields()
				})
				this.psdDialog = false
			},
			getWebsite(){//获取站点设置
			    websiteInfo({}).then(res=>{
			        this.siteLogo=res.data.siteBanner
			    })
			},
			logout(){//退出
				this.$confirm('确定要退出吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					logout({}).then(()=>{
						this.$message({
							type: 'success',
							message: '退出成功!',
							duration: 1000,
							onClose:()=>{
								this.$store.commit('user/setUserInfo',{})
                                this.$store.commit('user/setUnitInfo',{})
								this.$router.push({
									path:"/login"
								})
							}
						});
					})
				}).catch(() => {});
			},
			submitForm() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						const loading = this.$loading({
							lock: true,
							text: '拼命加载中...',
							spinner: 'el-icon-loading',
							background: 'rgba(0, 0, 0, 0.7)'
						});
						password(this.form).then(res=>{
							this.$message({
								message: res.errmsg,
								type: 'success',
								duration: '2000',
								onClose:()=>{
									loading.close()
									this.psdDialog=false
									this.$nextTick(() => {
										this.$refs['form'].clearValidate()
										this.$refs['form'].resetFields()
									})
								}
							});
						}).catch(()=>{
							loading.close()
						})
					} else {
						return false;
					}
				});
			},
			goPage(){//回官网首页
				this.$router.push({
					path:'/home'
				})
			}
		}
	}
</script>
<style lang='scss' scoped>
	.the_header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 40px;
		box-sizing: border-box;
		height: 70px;
		flex:none;
		background-color: #fff;
		box-shadow: 0px 2px 4px 0px rgba(204,204,204,0.5);
		.header_lt{
			display: flex;
			align-items: center;
			cursor: pointer;
			.logo_text{
				margin-left: 15px;
				color: #00AA73;
				white-space: nowrap;
				  width: 100%;
				p{
					line-height: 1;
				}
				p:nth-child(1){
					font-size: 17.2px;
					// color: #1A1A1A;
					font-weight: 600;
					margin-top: 7px;
					letter-spacing: 1px;
					white-space: nowrap;
				}
				p:nth-child(2){
					font-size: 14px;
					margin-top: 5px;
					white-space: nowrap;
					letter-spacing: 1px;
				}
			}
		}
		.header_rt{
			display: flex;
			align-items: center;
			// border: 1px solid #0f0;
			margin-right: 70px;
			>li{
				color: #4D4D4D;
				font-size: 16px;
				display: flex;
				align-items: center;
				padding: 0 30px;
				box-sizing: border-box;
				font-weight: 400;
				img{
					// border: 1px solid #f00;
					margin-right: 15px;
				}
			}
			li:nth-child(2){
				border-left: 2px solid #999;
				border-right: 2px solid #999;
				cursor: pointer;
			}
			li:nth-child(3){
				cursor: pointer;
			}
		}
		.form_dialog{
            border-top: 1px solid #E6E6E6;
            padding-top: 40px;
            .btn_wrap{
                text-align: center;
                // margin-top: 50px;
            }
        }
	}
</style>